
















































import { computed, defineComponent } from '@vue/composition-api'
import { QuestionnairePageEntity } from '../../../../api/@types'

type Props = {
  page: QuestionnairePageEntity
  pageCount: number
  isAutomatic: boolean
}

export default defineComponent({
  name: 'PageRow',
  props: {
    page: {
      type: Object,
      required: true,
    },
    pageCount: {
      type: Number,
      default: 1,
    },
    isAutomatic: {
      type: Boolean,
      default: true,
    },
  },
  setup(props: Props, context) {
    const store = context.root.$store
    const id = context.root.$route.params.id

    const onUp = () => {
      store.dispatch('questionnaire/changePageOrder', {
        pageId: props.page.id,
        type: 'up',
      })
    }

    const onDown = () => {
      store.dispatch('questionnaire/changePageOrder', {
        pageId: props.page.id,
        type: 'down',
      })
    }

    const disabledUp = computed(
      () => props.page.isThankPage || props.page.order === 1,
    )
    const disabledDown = computed(
      () => props.page.isThankPage || props.page.order === props.pageCount - 1,
    )

    const qType = props.isAutomatic ? 'automatic' : 'manual'

    return {
      id,
      disabledUp,
      disabledDown,
      onUp,
      onDown,
      qType,
    }
  },
})
